/**
 * Decodes a JWT token and extracts the expiration timestamp
 * @param token - The JWT token string
 * @returns The expiration timestamp in milliseconds, or null if the token is invalid or doesn't have an expiration
 */
export function getJwtExpiration(token: string): number | null {
  try {
    // JWT format: header.payload.signature
    const parts = token.split(".");
    if (parts.length !== 3) {
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];

    // Base64 decode (handle URL-safe base64)
    // Add padding if needed (Base64 requires length to be multiple of 4)
    let base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padding = base64.length % 4;
    if (padding) {
      base64 += "=".repeat(4 - padding);
    }
    const decodedPayload = atob(base64);

    // Parse the JSON payload
    const parsedPayload = JSON.parse(decodedPayload) as { exp?: number };

    // Extract the expiration claim (exp is in seconds, convert to milliseconds)
    if (parsedPayload.exp && typeof parsedPayload.exp === "number") {
      return parsedPayload.exp * 1000;
    }

    return null;
  } catch (error) {
    console.error("[auth] Failed to decode JWT token", { error });
    return null;
  }
}
